(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["login-page"]) return;
  try {
    
function initDorDeCasaLogin(){
  document.querySelectorAll('.ddc-auth__toggle').forEach(function(button){
    if(button.dataset.ready)return;
    const password=document.getElementById(button.getAttribute('aria-controls'));
    if(!password)return;
    button.dataset.ready='true';
    button.hidden=false;
    button.addEventListener('click',function(){
      const show=password.type==='password';
      password.type=show?'text':'password';
      button.textContent=show?button.dataset.hide:button.dataset.show;
      button.setAttribute('aria-pressed',String(show));
    });
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initDorDeCasaLogin);}else{initDorDeCasaLogin();}
document.addEventListener('shopify:section:load',initDorDeCasaLogin);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
function initDorDeCasaWishlist(){
  document.querySelectorAll('.ddc-wishlist').forEach(function(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const grid=root.querySelector('.ddc-wishlist-grid');
    const empty=root.querySelector('.ddc-wishlist-empty');
    const loading=root.querySelector('.ddc-wishlist-loading');
    const toolbar=root.querySelector('.ddc-wishlist-toolbar');
    const error=root.querySelector('.ddc-wishlist-error');
    const feedback=root.querySelector('.ddc-wishlist-feedback');
    const undo=root.querySelector('[data-wish-undo]');
    let removed=null;
    let generation=0;
    function read(){
      const raw=localStorage.getItem('wishlist');
      const value=raw?JSON.parse(raw):[];
      if(!Array.isArray(value))throw new Error('Invalid wishlist');
      return [...new Set(value.filter(h=>typeof h==='string'&&h.length>0&&h.length<300&&!/[\/?#]/.test(h)))];
    }
    function write(handles){
      localStorage.setItem('wishlist',JSON.stringify(handles));
      localStorage.setItem('user_wishlist_cnt',String(handles.length));
      document.querySelectorAll('.wishlist-counter').forEach(el=>el.textContent=String(handles.length));
    }
    function showError(message){error.querySelector('p').textContent=message;error.hidden=false;}
    function updateState(handles){
      const hasItems=handles.length>0;
      empty.hidden=hasItems;toolbar.hidden=!hasItems;
      root.querySelector('.ddc-wishlist-availability').hidden=!hasItems;
      root.querySelector('.ddc-wishlist-count').textContent=handles.length===1?root.dataset.countOne:root.dataset.countMany.replace('[count]',String(handles.length));
      document.querySelectorAll('.wishlist-counter').forEach(el=>el.textContent=String(handles.length));
    }
    function errorCard(handle){
      const card=document.createElement('article');card.className='ddc-wish-card';card.dataset.wishHandle=handle;
      const title=document.createElement('h2');title.textContent=root.dataset.itemError;card.append(title);
      const button=document.createElement('button');button.type='button';button.className='ddc-wish-remove';button.dataset.wishRemove='';button.textContent=root.dataset.remove;card.append(button);return card;
    }
    async function render(){
      const current=++generation;error.hidden=true;loading.hidden=false;grid.setAttribute('aria-busy','true');
      let handles;
      try{handles=read();}catch(e){loading.hidden=true;grid.setAttribute('aria-busy','false');empty.hidden=true;showError(root.dataset.storageError);return;}
      updateState(handles);grid.replaceChildren();
      const base=root.dataset.root.endsWith('/')?root.dataset.root:root.dataset.root+'/';
      let failed=false;
      const cards=await Promise.all(handles.map(async handle=>{
        try{
          const response=await fetch(base+'products/'+encodeURIComponent(handle)+'?view=wishlist');
          if(!response.ok)throw new Error('Product request failed');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const card=doc.querySelector('[data-wish-card]');
          if(!card)throw new Error('Product unavailable');
          card.dataset.wishHandle=handle;return card;
        }catch(e){failed=true;return errorCard(handle);}
      }));
      if(current!==generation||!root.isConnected)return;
      grid.replaceChildren(...cards);loading.hidden=true;grid.setAttribute('aria-busy','false');
      if(failed)showError(root.dataset.error);
    }
    root.addEventListener('click',async function(event){
      const removeButton=event.target.closest('[data-wish-remove]');
      if(removeButton){
        const card=removeButton.closest('[data-wish-handle]');
        try{
          const handles=read();const index=handles.indexOf(card.dataset.wishHandle);if(index<0)return;
          removed={handle:handles[index],index:index};handles.splice(index,1);write(handles);card.remove();updateState(handles);
          feedback.querySelector('p').textContent=root.dataset.removed;feedback.hidden=false;undo.hidden=false;undo.focus();
        }catch(e){showError(root.dataset.storageError);}return;
      }
      if(event.target.closest('[data-wish-undo]')&&removed){
        try{
          const handles=read();if(!handles.includes(removed.handle))handles.splice(Math.min(removed.index,handles.length),0,removed.handle);write(handles);removed=null;undo.hidden=true;
          feedback.querySelector('p').textContent=root.dataset.restored;await render();
          const firstLink=grid.querySelector('a');if(firstLink)firstLink.focus();
        }catch(e){showError(root.dataset.storageError);}return;
      }
      if(event.target.closest('[data-wish-retry]'))render();
    });
    window.addEventListener('storage',function(event){if(root.isConnected&&(event.key==='wishlist'||event.key===null))render();});
    render();
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initDorDeCasaWishlist);}else{initDorDeCasaWishlist();}
document.addEventListener('shopify:section:load',initDorDeCasaWishlist);

  } catch(e) { console.error(e); }
})();
})();
